import { useQuery } from '@tanstack/react-query'
import { useAuth } from '../auth/AuthContext'
import { apiFetch } from '../api/client'
import type { AccountUsage } from '../api/types'

// useAccountUsage fetches the account-wide Usage page's single data source —
// the account-summed storage + monthly bandwidth counters and their
// tier-resolved caps — from the dedicated GET /v1/me/usage endpoint.
//
// NOTE: this reads a server-summed aggregate, NOT a client-side sum over the
// owner's glows. That differs from the `max_glows` / `glows_used` pattern
// (where the SPA derives `glows_used` from the GET /v1/glows it already runs):
// account usage is the data plane's enforcement source of truth, so it has its
// own endpoint and is never reconstructed in the browser.
//
// Modeled on useGlowUsage: gated on an authenticated user (no glow id —
// account-scoped).
export function useAccountUsage() {
  const { idTokenProvider, user } = useAuth()
  return useQuery({
    queryKey: ['account-usage'],
    queryFn: ({ signal }) => apiFetch<AccountUsage>('/v1/me/usage', idTokenProvider, { signal }),
    enabled: !!user,
  })
}
